import { useContext, useCallback } from 'react';

import { REQUEST_ABORTED } from '../../../utils/cfetchWithAbort.ts';
import { DocErrors, ErrorRoles } from '../../../hooks/useUploadReducer.ts';
import { getErrorBody } from '../../../utils/getErrorBody.tsx';
import { containsRequiredError } from '../../../utils/containsRequiredError.tsx';
import { GOOGLE_EXPORT_ERRORS } from '../../../config/googleExportErrors.ts';
import { ImportStateContext } from '../../ImportStateContextProvider.tsx';

export const useGoogleBulkErrors = (): ((error: any, docName: string) => Promise<undefined>) => {
	const {
		docActions: { uploadDocFailure },
	} = useContext(ImportStateContext);

	return useCallback(
		async (error: any, docName: string): Promise<undefined> => {
			if (error === REQUEST_ABORTED) {
				uploadDocFailure(docName, {
					type: DocErrors.REQUEST_ABORTED_ERROR,
					role: ErrorRoles.ERROR,
				});
				return;
			}

			const errorBody = await getErrorBody(error);
			if (containsRequiredError(errorBody, GOOGLE_EXPORT_ERRORS.FILE_SIZE_LIMIT)) {
				uploadDocFailure(docName, {
					type: DocErrors.SIZE_GD_ERROR,
					role: ErrorRoles.ERROR,
				});
				return;
			}

			if (containsRequiredError(errorBody, GOOGLE_EXPORT_ERRORS.USER_RATE_LIMIT)) {
				uploadDocFailure(docName, {
					type: GOOGLE_EXPORT_ERRORS.USER_RATE_LIMIT,
					role: ErrorRoles.ERROR,
				});
				return;
			}

			uploadDocFailure(docName, {
				type: DocErrors.FAILED_UPLOAD_ERROR,
				role: ErrorRoles.ERROR,
			});
		},
		[uploadDocFailure],
	);
};
